import { useSelectedChain } from "@app/examples/ChainSelector";
import { PaginationBar } from "@components/PaginationBar";
import { NftCardV2 } from "@components/nft/NftCardV2";
import { useApi } from "@hooks/ApiHook";
import { UserResponse } from "baaanggg";
import React, { useState } from "react";

type Props = {
  user: UserResponse;
  refreshSignal?: number; // <— sinyal dari parent
};

export function MyNftTab({ user, refreshSignal = 0 }: Props) {
  const [page, setPage] = useState(1);
  const [nonce, setNonce] = useState(0); // <— sinyal lokal

  const { data: paginatedNft } = useApi(
    (api) => api.item.allNft({ ownerAddress: user.walletAddress, page }),
    [page, user?.walletAddress, nonce, refreshSignal] // <— trigger re-fetch
  );

  return (
    <div>
      <div className="js-collections-grid grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4">
        {paginatedNft?.data.map((nft) => {
          return <NftCardV2 nft={nft} />;
        })}
      </div>

      <div className="mt-5"></div>

      {paginatedNft && (
        <PaginationBar
          pagination={paginatedNft}
          currentPage={page}
          onPageChange={(page) => setPage(page)}
        />
      )}
    </div>
  );
}
